import Banner from '@carvana/ds-banner';
import { AlertCircle } from 'lucide-react';

type OwnProps = {
  zip: string;
  openCallback: (open: boolean) => void;
};

export default function DeliveryUnavailableBanner(props: OwnProps) {
  const { zip, openCallback } = props;

  return (
    <div data-testid="delivery-banner">
      <Banner
        align="center"
        icon={<AlertCircle size={16} />}
        open
        inline
        type="warning"
        className="flex w-full rounded-none border-0"
      >
        <Banner.Headline>Delivery unavailable for {zip}</Banner.Headline>
        <Banner.Button
          data-analytics-id="Delivery Banner - Change Location"
          data-testid="change-location"
          tabIndex={0}
          onKeyUp={e => e.key === 'Enter' && openCallback(true)}
          onClick={() => openCallback(true)}
        >
          Change location
        </Banner.Button>
      </Banner>
    </div>
  );
}
